import {
  BarChart2,
  User,
  Building2,
  CalendarDays,
  FileText,
  ClipboardList,
  Settings,
  UserPlus,
} from "lucide-react";

export const NAVIGATION_CONFIG = {
  superadmin: [
    { name: "Dashboard", icon: BarChart2, color: "#6366f1", href: "/superadmin/dashboard" },
    { name: "Account Requests", icon: UserPlus, color: "#14B8A6", href: "/superadmin/account-requests" },
    { name: "Leaves", icon: CalendarDays, color: "#10B981", href: "/superadmin/manage-leave-types" },
    { name: "Users", icon: User, color: "#EC4899", href: "/superadmin/users" },
    { name: "Reports", icon: FileText, color: "#3B82F6", href: "/superadmin/reports" },
  ],
  admin: [
    { name: "Dashboard", icon: BarChart2, color: "#6366f1", href: "/dashboard" },
    { name: "Users", icon: User, color: "#EC4899", href: "/employee" },
    { name: "Role Management", icon: Building2, color: "#8B5CF6", href: "/manage-roles" },
    { name: "Leaves", icon: CalendarDays, color: "#10B981", href: "/leaves" },
    { name: "Attendance", icon: ClipboardList, color: "#F59E0B", href: "/attendance" },
    { name: "Reports", icon: FileText, color: "#3B82F6", href: "/reports" },
     { name: "Settings", icon: Settings, color: "#EF4444", href: "/email-settings" }
  ],
  user: [
    { name: "Dashboard", icon: BarChart2, color: "#6366f1", href: "/user/dashboard" },
    { name: "Leaves", icon: CalendarDays, color: "#10B981", href: "/user/leave" },
    { name: "Attendance", icon: ClipboardList, color: "#F59E0B", href: "/user/attendance" },
  ]
};

export const ROLE_TITLES = {
  superadmin: "SuperAdmin",
  admin: "Admin",
  user: "Menu"
};